import React from 'react';

const Danke = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="bg-white rounded-2xl p-12 shadow-2xl">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Vielen Dank für Ihre Nachricht!
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Wir haben Ihre Anfrage erhalten und werden uns schnellstmöglich bei Ihnen melden.
          </p>
          
          <div className="space-y-4 text-left bg-amber-50 p-6 rounded-lg mb-8">
            <h3 className="font-semibold text-gray-900">Was passiert als nächstes?</h3>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="text-amber-600 mr-2">•</span>
                Wir prüfen Ihre Anfrage und verfügbare Termine
              </li>
              <li className="flex items-start">
                <span className="text-amber-600 mr-2">•</span>
                Sie erhalten binnen 24h eine persönliche Antwort
              </li>
              <li className="flex items-start">
                <span className="text-amber-600 mr-2">•</span>
                Gemeinsam planen wir Ihr perfektes Event
              </li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <a 
              href="/" 
              className="inline-block bg-amber-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-amber-700 transition-colors duration-200"
            >
              Zurück zur Startseite
            </a>
            
            <div className="text-sm text-gray-500">
              <p>Fragen? Rufen Sie uns an: <a href="tel:+4916090133776" className="text-amber-600 hover:underline">+49 160 90133776</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Danke;